import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class PaymentFormService {

  constructor(private _http: HttpClient) {
  }

  getAll() {
    return this._http.get<any>('api/dictionary/paymentForm/all');
  }

  getGrantTypes(paymentFormId?: number) {
    if (!paymentFormId) {
      paymentFormId = 0;
    }
    return this._http.get<any>(`api/dictionary/paymentForm/getGrantTypes/${paymentFormId}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/common_services/payment-form.service.ts